/**
 * API
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
import ApiVersion from '@/modules/app-router/model/ApiVersion';
import KeyValuePair from '@/modules/core/support/KeyValuePair';

export default class Api {
    public id = 0
    public name = ''
    public versions: ApiVersion[] = []

    public get isNew () {
        return !this.id
    }

    public static deserialize (data: KeyValuePair) {
        return Object.assign(new this(), {
            id: data.id,
            name: data.name,
            versions: data.versions.map((v: KeyValuePair) => ApiVersion.deserialize(v)),
        })
    }
}
